import React, { forwardRef, Ref } from "react";
import DiagonalArrowIcon from "../../../generated/DiagonalArrowIcon/DiagonalArrowIcon20";
import { GeneratedIconProps } from "../../icon/GeneratedIconProps";
import { Icon } from "../../icon/Icon";
import BackIcon from "./../../../generated/BackIcon/BackIcon20";

type Rotations = 0 | 45 | 90 | 135 | 180 | 225 | 270 | 315;
export interface DirectionalArrowIconProps extends GeneratedIconProps {
    /** Automatically set rotation based on value. 0 is vertical. */
    rotation: Rotations;
    /**
     * The size to render the icon at.
     */
    size: 20;
}

const getArrow = (rotation: Rotations) => {
    switch (rotation) {
        case 45:
        case 135:
        case 225:
        case 315:
            return <DiagonalArrowIcon color="currentColor" />;
        default:
            return <BackIcon color="currentColor" />;
    }
};

const getRotation = (rotation: Rotations) => {
    switch (rotation) {
        case 45:
        case 135:
        case 225:
        case 315:
            return rotation - 45;
        default:
            return rotation + 90;
    }
};

export const DirectionalArrowIcon = forwardRef(
    ({ color, size, rotation, style, ...rest }: DirectionalArrowIconProps, ref: Ref<HTMLElement>) => (
        <Icon
            color={color}
            ref={ref}
            size={size}
            style={{ transform: `rotate(${getRotation(rotation)}deg)`, ...style }}
            {...rest}
        >
            {getArrow(rotation)}
        </Icon>
    )
);

DirectionalArrowIcon.displayName = "DirectionalArrowIcon";
